import React from 'react';
import RedesignedProfileCard from '../components/TalentProfile/RedesignedProfileCard';
import { ExtractedDocumentData } from '../types';
import AppLayout from '../components/Layout/AppLayout';

const ProfileDemo: React.FC = () => {
  // Sample data matching the ExtractedDocumentData interface
  const sampleData: ExtractedDocumentData = {
    file_path: "/documents/david_martinez_review.pdf",
    employee_profile: {
      name: "David Martinez",
      level: "Senior",
      tenure: "5+ years",
      role: "Senior Product Manager",
      team: "Product Team",
      manager: "Sarah Johnson",
      key_accomplishments: [
        "Led successful product launch",
        "Increased user engagement by 40%",
        "Managed cross-functional team of 12"
      ],
      professional_experience: "Experienced product manager with expertise in user experience design, data analytics, and team leadership. Successfully launched multiple products and consistently exceeded performance targets.",
      summary: "High-performing senior product manager with strong leadership skills and proven track record of delivering results. Excellent communicator and strategic thinker."
    },
    raw_text: "Sample extracted text from performance review document...",
    slides_count: 15,
    extraction_metadata: {
      processing_method: "AI-powered extraction",
      processing_time: "2.3 seconds",
      total_text_length: 2847,
      model_id: "gpt-4-turbo"
    }
  };

  return (
    <AppLayout>
      <div className="min-h-screen">
        <RedesignedProfileCard extractedData={sampleData} />
      </div>
    </AppLayout>
  );
};

export default ProfileDemo;